import React, { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FormLabel, Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import FileUpload from 'components/FileUpload/FileUpload'

function NuevaInformacion(props) {
	const { guardar, setQueMostrar } = props

	const datosInicial = {
		titulo: '',
		orden: '',
		imagen: ''
	}
	const [datos, setDatos] = useState(datosInicial)

	const handleClose = () => {
		setQueMostrar('')
		setDatos(datosInicial)
	}

	const handleProcesar = (e) => {
		e.preventDefault()

		const data = {
			...datos,
		}
		
		guardar(data)
		handleClose()
	}

	const handleChange = (value, key) => {
		const datosCopia = { ...datos }
		datosCopia[key] = value
		setDatos(prev => datosCopia)
	}

	const handleSeleccionImagen = (files) => {
		setDatos({ ...datos, imagen: files[0] })
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Nueva información" />
			<Offcanvas.Body>
				<h1>Datos de la información</h1>
				<Row>
					<Col sm={12} md={6}>
						<Form onSubmit={handleProcesar} className="ms-4">
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="informacion-titulo">
										<FormLabel>Título</FormLabel>
										<Form.Control
											value={datos.titulo}
											type="text"
											onChange={(e) => handleChange(e.target.value, 'titulo')}
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3 col-md-3" controlId="informacion-orden">
										<FormLabel>Orden</FormLabel>
										<Form.Control
											value={datos.orden}
											type="number"
											onChange={(e) => handleChange(e.target.value, 'orden')}
										/>
									</Form.Group>
								</Col>
							</Row>
						</Form>
					</Col>
					<Col sm={12} md={6}>
						<FileUpload
							title="Imagen"
							accept=".png, .jpg, .jpeg, .ppt, .pptx, .pdf"
							buttonText="Elegir"
							buttonTextSingular="imagen"
							updateFiles={handleSeleccionImagen}
						/>
					</Col>
				</Row>
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-tertiary" onClick={handleClose} className="me-2">
					Cancelar
				</Button>
				<Button variant="primary" onClick={handleProcesar}>
					Guardar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default NuevaInformacion